import { z } from "zod";

export const assignmentInputSchema = z.object({ assignedUserId: z.uuid().nullable().optional() });
export const assigneeSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  status: z.enum(["active", "inactive", "removed"]),
});
export type Assignee = z.infer<typeof assigneeSchema>;
export type AssigneeOption = { id: string; name: string; email: string | null };

export const assigneeFilterSchema = z.union([z.uuid(), z.literal("unassigned")]).optional();
